import { h, Component } from 'preact';
import { translate } from 'react-i18next';


class TwoFactorFrequency extends Component {

	updateFrequency = (e) => {
    this.props.update('frequency',e.target.value);
    this.setState({ select2FAfrequency: e.target.value });
  }

  shouldComponentUpdate(nextProps) {
    if ( nextProps.twoFactorData !== undefined && this.state.select2FAfrequency === 'initial' ) {
      this.setState({select2FAfrequency: nextProps.twoFactorData.validationPeriod.toLowerCase() });
    }
  }

  componentDidMount() {
    this.setState({ select2FAfrequency: this.props.twoFactorData.validationPeriod.toLowerCase() });
  }

  constructor(props) {
  	super(props);
  	this.state = {
  		select2FAfrequency: 'initial'
  	};
  }

	render() {
    const { t } = this.props;
		return (
        <div className="c-TwoFactorFrequency">
          <h4>{t('Verification Frequency')}</h4>
          <p>{t('Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.')}</p>
          <select onChange={this.updateFrequency} id="2fa-frequency" value={this.state.select2FAfrequency}>
            <option selected disabled value="none">{t('Choose Method')}</option>
            <option value="periodic">{t('Periodic')}</option>
            <option value="everytime">{t('Everytime')}</option>
          </select>
        </div>
		);
	}
}

export default translate(['common'], { withRef: true })(TwoFactorFrequency);


// WEBPACK FOOTER //
// ./components/TwoFactorFrequency.js